import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { AuthService } from 'src/app/core/services/authentication.service';
import { CargoTripAnomalyService } from 'src/app/modules/cargo/cargo-trip-anomaly/cargo-trip-anomaly.service';
import { environment } from "src/environments/environment";
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { Utils } from 'src/app/core/resources/utils';
import { Patterns } from 'src/app/core/resources/patterns';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { BasicCompany } from 'src/app/core/interfaces/basicCompany';
import { Company } from 'src/app/core/interfaces/company';
import { DateManager } from 'src/app/core/managers/date.manager';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { Role } from 'src/app/core/interfaces/role';
import { Global } from 'src/app/core/resources/global';
import { Tag } from 'src/app/core/interfaces/tag';
import { CompaniesService } from 'src/app/modules/administration/companies/list-companies.service';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { Subscription } from 'rxjs';
import { ServiceRequestStateEnum } from 'src/app/core/enums/serviceRequestState.enum';
import { TravelExpensesService } from 'src/app/core/services/travel-expenses.service';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { MatSelectChange } from '@angular/material/select';
import { Companies } from 'src/app/core/resources/companies';
import { TravelExpensesStateDict, TravelExpensesStateEnum } from 'src/app/core/enums/travelExpensesState.enum';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { SatelliteLockService } from 'src/app/modules/satellite-lock/satellite-lock.service';
import { SatelliteLockType } from 'src/app/core/interfaces/satelliteLockType';
import { SatelliteLockStateDevice } from 'src/app/core/enums/satelliteLockStateDevice.enum';

@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss'],
  providers: [CargoManager]
})

export class ListFilterComponent implements OnInit {
  @Input() filterBy: "cargo" | "company" | "vehicle" | "user" | "serviceRequests" | "satelliteLock" = "cargo";
  @Input() options: FilterModel[];
  @Input() typeList: string;
  @Output() refreshList: EventEmitter<any> = new EventEmitter();
  permission = Permission;
  readonly SatelliteLockStateDevice = SatelliteLockStateDevice;
  staticFilters = {};
  // Empresa de transporte en pagos y facturación: viene de ?transportCompanyId= y se aplica siempre.
  initialTransportCompanyId: string = null;
  private transportCompanyResolved: boolean = false;
  filterPayment = "pendingToPay";
  filterCharges: '1' | '2' | '3' = '1';
  filterAdvanceState = new FormControl("requested");
  initialFilters = {};
  form: FormGroup;
  companySelected = new FormControl('');
  companiesControl: FormControl = new FormControl();
  formControlSatelliteLockType: FormControl = new FormControl();
  filterAmountValue;
  incidents;
  originCity = new FormControl('');
  destinationCity = new FormControl('');
  dateLoad = new FormControl(null);
  endDate = new FormControl(null);
  creationDateInitial: FormControl = new FormControl();
  creationDateFinal: FormControl = new FormControl();
  tagControl: FormControl = new FormControl();
  filterErrorManifest = new FormControl(false);
  showLateralFilter = false;
  cargoTypes = ["Importación", "Exportación", "Nacional", "Internacional", "Urbana", "Última milla"];
  riskProfiles = [{ id: '1', name: 'Riesgo bajo' }, { id: '2', name: 'Riesgo medio' }, { id: '3', name: 'Riesgo alto' }];
  cargoTabsLoadingRoutes = ["emptyContainers", "urbanRoutes", "lastMileRoutes", "nationalRoutes", "importRoutes", "exportRoutes", "internationalRoutes"];
  cargoTabsPayment = ['paymentAdvanceCargo', 'paymentExtraAdvanceCargo', 'paymentAdditionalCostsCargo', 'paymentBalanceCargo']
  optionsCompanyfilter: OptionsAutocomplete = {
    title: 'Compañía',
    optionAll: true,
  };
  optionsCompanies: OptionsAutocomplete = {
    title: 'Añadir Compañía',
    optionAll: false,
  };
  optionsSatelliteLockType: OptionsAutocomplete = {
    title: 'Tipo de candado satelital',
  };
  isOpen: boolean = false;
  optionsCityOrigin: OptionsAutocomplete = {
    title: 'Orígen',
  }
  optionsCityDestination: OptionsAutocomplete = {
    title: 'Destino',
  }
  validate: string = '';
  cityControlOrigin: FormControl = new FormControl();
  cityControlDestination: FormControl = new FormControl();
  companyRegisterList: BasicCompany[] = [];
  roles: Role[] = [];
  tags: Tag[] = [];
  userStates = [{ value: "true", name: 'Activo' }, { value: "false", name: 'Inactivo' }];
  isRootNit: boolean;
  optionsDocumentUser: OptionsAutocomplete = {
    title: 'N° doc conductor',
    showUserName: true,
    showSearchHint: false
  }
  optionsUserClient: OptionsAutocomplete = {
    title: 'Usuario web',
    showXMark: true,
    appearance: 'outline',
  }
  documentDriverControl: FormControl = new FormControl();
  userClientControl: FormControl = new FormControl();
  companySub: Subscription;
  companiesSub: Subscription;
  satelliteLockTypeSub: Subscription;
  cityOriginSub: Subscription;
  cityDestinationSub: Subscription;
  documentDriverSub: Subscription;
  userClientSub: Subscription;
  travelExpenseTypes: Array<CatalogItem> = [];
  travelExpensesCheckingStates: CatalogItem[] = [];
  travelExpenseStates: Array<{ value: string, name: string }> = [{ value: 'true', name: 'Pagado' }, { value: 'false', name: 'Por pagar' }];
  vehicleTypes: CatalogItem[] = [];
  filterAccountState = { value: { stateAccountAdvance: null, stateAccountBalance: null }, name: 'Todos' };
  listStateAccountBank = [
    { value: { stateAccountAdvance: null, stateAccountBalance: null }, name: 'Todos' },
    { value: { stateAccountAdvance: "true", stateAccountBalance: null }, name: 'Anticipo Registrado' },
    { value: { stateAccountAdvance: null, stateAccountBalance: "true" }, name: 'Saldo Registrado' },
    { value: { stateAccountAdvance: "true", stateAccountBalance: "true" }, name: 'Anticipo y Saldo Registrado' },
    { value: { stateAccountAdvance: "false", stateAccountBalance: null }, name: 'Anticipo sin Registrar' },
    { value: { stateAccountAdvance: null, stateAccountBalance: "false" }, name: 'Saldo sin Registrar' },
    { value: { stateAccountAdvance: "false", stateAccountBalance: "false" }, name: 'Anticipo y Saldo sin Registrar' }
  ];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public utils: Utils,
    private adminUsersService: AdminUsersService,
    private formBuilder: FormBuilder,
    public cargoManager: CargoManager,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef,
    public patterns: Patterns,
    public snackBarService: SnackBarService,
    private cargoTripAnomalyService: CargoTripAnomalyService,
    private dateManager: DateManager,
    public global: Global,
    private companiesService: CompaniesService,
    private travelExpensesService: TravelExpensesService,
    private vehiclesService: VehiclesService,
    private satelliteLockService: SatelliteLockService
  ) { }

  ngOnInit() {
    this.initialTransportCompanyId = this.route.snapshot.queryParams['transportCompanyId'] || null;
    this.isRootNit = this.authService && this.authService.userIsFromRootNit();
    this.getOptionsByMethods();
    this.initStaticFilters();
    this.initDynamicFilters();
  }

  ngAfterViewInit() {
    this.initDynamicFilters();
    this.getFromSessionStorage();
    this.setOptions();
    this.setSubscriptions();

    if (this.typeList != 'paymentTravelExpenses')
      this.search();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  getOptionsByMethods() {
    if (this.filterBy === "user") {
      if (!this.roles.length) {
        this.adminUsersService.getRolesCompany(this.authService.getCompany().companyId).toPromise()
          .then((success: Role[]) => this.roles = success)
          .catch(() => this.roles = [])
          .finally(() => {
            this.roles.push(this.global.defaultRoles.webUserPendingActivate);
            this.roles = this.roles.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
          });
      }
    } else if (this.filterBy === "cargo") {
      //Aquí se usaría un servicio para obtener las tags
      this.companiesService.getLabelTags().subscribe(
        (success) => {
          if (success && success.length) this.tags = success;
        }, () => { }
      )
      if (this.typeList == 'paymentTravelExpenses') {
        this.travelExpensesService
          .getTypes()
          .subscribe((travelExpenseTypes) => {
            this.travelExpenseTypes = travelExpenseTypes && travelExpenseTypes.length ? travelExpenseTypes : [];
            if (Array.isArray(this.travelExpenseTypes) && this.travelExpenseTypes[0]) {
              this.staticFilters['paid'] = this.travelExpenseStates[1].value;
              this.setStaticFilterAndSearch('travelExpensesType', travelExpenseTypes[0].name);
            } else this.search();
          },
            () => this.search());
      }
      if (this.staticFiltersByOptions.some(option => option.filterName === Filter.showFilterTravelExpensesState)) {
        this.travelExpensesService.getGlobalStatusTypes().subscribe(
          (success) => this.travelExpensesCheckingStates = success && success.length ? success : [],
          () => this.travelExpensesCheckingStates = []
        );
      }
    } else if (this.filterBy === "vehicle") {
      this.vehiclesService.getVehicleTypes().subscribe(
        (success) => this.vehicleTypes = success && success.catalog && success.catalog.length ? success.catalog.filter(vehicle => vehicle.id !== '24' && vehicle.id !== '41') : [],
        () => this.vehicleTypes = []
      );
    }
  }

  setOptions() {
    if (this.isRootNit) {
      const variable = this.filterBy === "vehicle" ? 'companyId' : 'nit';
      this.optionsCompanyfilter['initialNit'] = this.form && this.form.get(variable) && this.form.get(variable).value ? this.form.get(variable).value : '';
    }
    const typeField = this.filterBy === 'satelliteLock' ? 'typeName' : 'typeNameLock';
    this.optionsSatelliteLockType['initialValue'] = this.form && this.form.get(typeField) && this.form.get(typeField).value ? this.form.get(typeField).value : '';
    this.optionsCityOrigin['initialValue'] = this.form && this.form.get('origin') && this.form.get('origin').value ? this.form.get('origin').value : '';
    this.optionsCityOrigin = { ...this.optionsCityOrigin };
    this.optionsCityDestination['initialValue'] = this.form && this.form.get('destination') && this.form.get('destination').value ? this.form.get('destination').value : '';
    this.optionsCityDestination = { ...this.optionsCityDestination };
    this.optionsDocumentUser['initialValue'] = this.form && this.form.get('driver') && this.form.get('driver').value ? this.form.get('driver').value : '';
    this.optionsDocumentUser = { ...this.optionsDocumentUser };
    const userSession = this.authService.getUserSession();
    if (this.form && this.form.get('userClientDocument') && this.form.get('userClientDocument').value)
      this.optionsUserClient['initialValue'] = this.form.get('userClientDocument').value;
    else if (this.filtersByOptions.showFilterPrevalidation && userSession && userSession.information && userSession.information.document)
      this.optionsUserClient['initialValue'] = userSession.information.document;
    else this.optionsUserClient['initialValue'] = '';
    if (this.filtersByOptions.showFilterPrevalidation) this.optionsUserClient['title'] = 'Creador del servicio';
    this.optionsUserClient = { ...this.optionsUserClient };
  }

  setSubscriptions() {
    this.companySub = this.companySelected.valueChanges.subscribe(() => {
      const company: Company = this.companySelected.value;
      if (!!company && !!company.companyId) {
        if (this.filterBy === "vehicle")
          this.form.get('companyId').setValue(company.companyId);
        else {
          this.form.get('nit').setValue(company.companyId);
          this.form.get('exclusive') && this.form.get('exclusive').setValue(company.exclusive);
        }
      } else {
        if (this.filterBy === "vehicle")
          this.form.get('companyId').setValue("");
        else {
          this.form.get('nit').setValue("");
          this.form.get('exclusive') && this.form.get('exclusive').setValue("");
        }
      }
    });
    this.companiesSub = this.companiesControl.valueChanges
      .subscribe((value) => {
        if (value && value.companyId) {
          const companies: string[] = this.form.get('nits').value;
          if (companies.includes(value.companyId)) this.snackBarService.openSnackBar('Esta compañía ya está en la lista', undefined, 'alert');
          else if (companies.length >= 10) this.snackBarService.openSnackBar('Solo es posible filtrar por un máximo de 10 compañías simultaneamente', undefined, 'alert');
          else {
            this.form.get('nits').setValue([...companies, value.companyId]);
            this.optionsCompanies = {
              title: 'Añadir Compañía',
              optionAll: true,
              initialNit: ''
            }
          }
        }
      })

    this.satelliteLockTypeSub = this.formControlSatelliteLockType.valueChanges
      .subscribe(value => {
        const typeField = this.filterBy === 'satelliteLock' ? 'typeName' : 'typeNameLock';
        if (this.form.get(typeField)) {
          this.form.get(typeField).setValue(value && value.name ? value.name : '');
        }
      });
    this.cityOriginSub = this.cityControlOrigin.valueChanges
      .subscribe(value => this.form.get('origin').setValue(value && value.name ? value.name : ''))

    this.cityDestinationSub = this.cityControlDestination.valueChanges
      .subscribe(value => this.form.get('destination').setValue(value && value.name ? value.name : ''))
    if (this.filterBy !== 'serviceRequests') {
      this.cargoTripAnomalyService.getTripAnomaly().subscribe((success: any) => {
        if (success) this.incidents = success;
      });
    }

    this.documentDriverSub = this.documentDriverControl.valueChanges
      .subscribe(value => {
        if (value && value.information && value.information.document) this.form.get('driver').setValue(value.information.document);
      });

    this.userClientSub = this.userClientControl.valueChanges
      .subscribe(value => {
        if (!this.form.get('userClientDocument')) return;
        const previousValue = this.form.get('userClientDocument').value;
        this.form.get('userClientDocument').setValue(value && value.information && value.information.document ? value.information.document : '');
        if (this.filtersByOptions.showFilterPrevalidation && previousValue !== this.form.get('userClientDocument').value) this.search();
      });
  }
  private getFromSessionStorage() {
    let dinamicFilters = sessionStorage.getItem("_filterListDynamic");
    if (dinamicFilters && dinamicFilters !== "null") {
      const filtersFormatted = this.utils.decodeFilters(dinamicFilters);
      Object.keys(filtersFormatted).forEach(key => {
        if (['dateLoad', 'endDate', 'creationDateInitial', 'creationDateFinal'].includes(key))
          this[key] = new FormControl(DateManager.stringToDate(filtersFormatted[key], 'YYYY-MM-DD ZZ'));
        if (key === "errorManifest")
          this.filterErrorManifest.setValue(decodeURIComponent(filtersFormatted[key]) === 'true');
        this.initialFilters[key] = filtersFormatted[key];
      });
      if (Object.keys(filtersFormatted).includes('stateAccountAdvance') || Object.keys(filtersFormatted).includes('stateAccountBalance')) {
        const option = this.listStateAccountBank.find(option =>
          option.value.stateAccountAdvance == filtersFormatted['stateAccountAdvance']
          && option.value.stateAccountBalance == filtersFormatted['stateAccountBalance']
        );
        if (option) this.filterAccountState = option;
      }
    } else {
      this.initialFilters = {};
    }
    let staticFilters = sessionStorage.getItem("_filterListStatic");
    let options = sessionStorage.getItem("_currentOptions");

    if (options === JSON.stringify(this.filtersByOptions) && staticFilters && staticFilters !== null) {
      let storedFilters = this.parseQueryString(staticFilters);
      for (const key in this.staticFilters) {
        // Verifica si la llave está presente en storedFilters y si el valor no es nulo
        if (key in storedFilters && storedFilters[key] !== null && storedFilters[key] !== undefined) {
          // Establece el valor correspondiente en this.staticFilters
          if (this.filtersByOptions) {
            if (this.filtersByOptions.showFilterPaymentAdvanceCargo && storedFilters['advanceState'] === true && key === 'advanceState') this.staticFilters['requestedAdvance'] = '';
            else if (this.filtersByOptions.showFilterPaymentAdditionalCostsCargo && storedFilters['additionalCostPaid'] === true && key === 'additionalCostPaid') {
              this.staticFilters['additionalCost'] = '';
              this.staticFilters['states'] = [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE];
            }
            else if (this.filtersByOptions.showFilterPaymentBalanceCargo) {
              if (storedFilters['paymentType'] && storedFilters['fastPayment']) {
                this.filterPayment = "fastPay";
                this.staticFilters["paid"] = "";
                this.staticFilters["approval"] = "";
              } else if (storedFilters['paymentType']) {
                this.filterPayment = "pendingToPay";
                this.staticFilters["fastPayment"] = "";
                this.staticFilters["paid"] = "";
              } else {
                this.filterPayment = "paid";
                this.staticFilters["fastPayment"] = "";
                this.staticFilters["paymentType"] = "";
              }
            }
            else if (this.filtersByOptions.showFilterCharges) {
              if (storedFilters['cashed'] === false)
                this.filterCharges = '1'; //{ cashed: false, checked: '' };
              else if (storedFilters['checked'] === false)
                this.filterCharges = '2'; //{ cashed: true, checked: false };
              else
                this.filterCharges = '3'; //{ cashed: true, checked: true };
            }
          }
          if (!this.isTabLoadingRoutes)
            this.staticFilters[key] = storedFilters[key];
        }
      }
    }
    this.form.patchValue(this.initialFilters);
  }


  parseQueryString(queryString: string): { [key: string]: string | boolean | string[] } {
    const params = new URLSearchParams(queryString);
    const result: { [key: string]: string | boolean | string[] } = {};

    params.forEach((value, key) => {
      // Intenta convertir a boolean si es "true" o "false"
      if (value === 'true' || value === 'false') {
        result[key] = value === 'true';
      } else {
        // Divide por comas si es una lista
        const values = value.split(',');
        result[key] = values.length > 1 ? values : value;
      }
    });

    return result;
  }


  private cleanSessionStorage() {
    sessionStorage.setItem("_filterListDynamic", null);
  }
  private updateSessionStorage(filtersToSave: string, type: 'dynamic' | 'static') {
    sessionStorage.setItem(type === 'dynamic' ? "_filterListDynamic" : "_filterListStatic", filtersToSave ? filtersToSave : null);
    if (type === 'static') sessionStorage.setItem("_currentOptions", JSON.stringify(this.filtersByOptions));
  }

  //Filtros estáticos (siempre hay uno aplicado)
  public initStaticFilters() {
    if (this.staticFiltersByOptions.length) {
      this.staticFiltersByOptions.forEach(option => {
        this.staticFilters = { ...option.controls };
      });
    }
    else this.staticFilters = {};
    if (this.filterBy === "cargo") {
      let exceptionsToSetState = this.staticFiltersByOptions.some(option => [
        Filter.showFilterPaymentAdditionalCostsCargo,
        Filter.showFilterCharges,
        Filter.showFilterCreationDateInitial,
        Filter.showFilterTravelExpensesState,
        Filter.showFilterWithoutPayment,
        Filter.showFilterPrevalidation,
        Filter.showFilterPaymentExtraAdvanceCargo
      ].includes(option.filterName));
      const initialCargoState = this.getInitialCargoStateByTypelist(this.typeList);
      if (!exceptionsToSetState && initialCargoState) this.staticFilters['state'] = initialCargoState;
      this.setFieldsByTab(this.typeList);
      if (!this.isRootNit) this.staticFilters['nit'] = this.authService.getUserSession().clientCompanyId;
    }
    else if (this.filterBy === "user") {
      if (this.staticFiltersByOptions.some(option => option.filterName === Filter.showFilterStateUser))
        this.staticFilters = { type: "userClient" };
      if (!this.isRootNit) this.staticFilters['nit'] = this.authService.getUserSession().clientCompanyId;
    }
    else if (this.filterBy === "serviceRequests") {
      const filter = this.getInitialServiceRequestStateByTypelist(this.typeList);
      if (filter) {
        const key = Object.keys(filter)[0];
        this.staticFilters[key] = key === 'publish' ? false : filter[key];
      }
    }
    else if (this.filterBy === "vehicle") {
      if (!this.isRootNit) this.staticFilters['companyId'] = this.authService.getUserSession().clientCompanyId;
    }
    else {
      this.staticFilters = {};
    }
  }

  private getInitialCargoStateByTypelist(typeList: string): CargoStateEnum {
    let state: CargoStateEnum;
    switch (typeList) {
      case 'scheduledLoads':
        state = CargoStateEnum.ACCEPTED;
        break;
      case 'loadsInNegotiation':
        state = null;
        break;
      case 'rndcTabs':
        // States for RNDC are resolved in loadMinistryRetryCargos (rndc-utils.ts)
        // using the states array param. Setting a single state here would conflict.
        state = null;
        break;
      case 'loadsFinished':
      case 'balance':
      case 'approvePayments':
      case 'rndcFulfillments':
      case 'paymentBalanceCargo':
        state = CargoStateEnum.END_SERVICE;
        break;
      case 'request':
        state = CargoStateEnum.REQUEST;
        break;
      case 'expired':
        state = CargoStateEnum.EXPIRED;
        break;
      case 'deleted':
        state = CargoStateEnum.DELETED;
        break;
      case 'paymentTravelExpenses':
        // state del viático
        state = 'true' as any as CargoStateEnum;
        break;
      default:
        if (!['transportRequests', 'paymentAdvanceCargo'].includes(this.typeList))
          state = CargoStateEnum.START_SERVICE;
        break;
    }
    return state;
  }

  private getInitialServiceRequestStateByTypelist(typeList: string): { [key: string]: ServiceRequestStateEnum } {
    let staticFilter: { [key: string]: ServiceRequestStateEnum } = {};
    switch (typeList) {
      case 'assignedServiceRequests':
        staticFilter = { requestState: ServiceRequestStateEnum.ACCEPTED };
        break;
      case 'notAssignedServiceRequests':
        staticFilter = { requestState: ServiceRequestStateEnum.REQUESTED };
        break;
      case 'notPublishedServiceRequests':
        staticFilter = { publish: ServiceRequestStateEnum.NOT_PUBLISHED };
        break;
      default:
        staticFilter = {};
        break;
    }
    return staticFilter;
  }


  private setFieldsByTab(tab: string) {
    if (this.isTabLoadingRoutes) {
      const emptyContainerServiceTypes = [
        "Contenedor vacío express",
        "Contenedor vacío con carga de compensación"
      ];
      const loadedServiceTypes = [
        "Carga consolidada",
        "Carga expresa",
        "Contenedor lleno express",
        "Contenedor lleno consolidado"
      ];
      this.staticFilters['serviceTypes'] = tab === "emptyContainers" ? emptyContainerServiceTypes : loadedServiceTypes;
      const tripTypeByTab = {
        urbanRoutes: "Urbana",
        lastMileRoutes: "Última milla",
        importRoutes: "Importación",
        exportRoutes: "Exportación",
        internationalRoutes: "Internacional",
        nationalRoutes: "Nacional"
      };
      this.staticFilters['tripTypeName'] = tripTypeByTab[tab] ? tripTypeByTab[tab] : "";
    } else if (this.isTabPayment) {
      this.staticFilters['paymentType'] =
        tab === "paymentExtraAdvanceCargo" || tab === "paymentAdvanceCargo" ? "advance" :
          tab === "paymentAdditionalCostsCargo" ? "additionalCost" : "balance";
    }
  }
  get isTabLoadingRoutes(): boolean {
    return this.typeList && this.cargoTabsLoadingRoutes.includes(this.typeList);
  }
  get hasFastPaymentEnabled(): boolean {
    return (this.authService && !!this.authService.getCompanySaaS() && !!this.authService.getCompanySaaS().fastPaymentEnabled) || this.utils.isTeclogiUserOrClient;
  }
  get isTabPayment(): boolean {
    return this.typeList && this.cargoTabsPayment.includes(this.typeList);
  }
  get actualStaticFilters() {
    let filters = {}
    Object.keys(this.staticFilters).forEach(key => {
      let val = this.staticFilters[key];
      if (val !== null && val !== undefined && val !== "") {
        filters[key] = val;
      }
    })
    return filters;
  }
  //Métodos para editar filtros estáticos
  public setStaticFilterAndSearch(field: string, value, closeLateralFilter: boolean = false) {
    this.staticFilters[field] = value;
    if (closeLateralFilter) this.closeLateralFilter();
    this.search();
  }
  public setFilterPayment(value) {
    this.filterPayment = value;
    switch (value) {
      case "fastPay":
        this.staticFilters["fastPayment"] = true;
        this.staticFilters["paid"] = "";
        this.staticFilters["approval"] = "";
        this.staticFilters["paymentType"] = "balance";
        break;
      case "pendingToPay":
        this.staticFilters["fastPayment"] = "";
        this.staticFilters["paid"] = "";
        this.staticFilters["approval"] = "Approved";
        this.staticFilters["paymentType"] = "balance";
        this.form.get('approval') && this.form.get('approval').setValue('');
        break;
      case "paid":
        this.staticFilters["fastPayment"] = "";
        this.staticFilters["paid"] = true;
        this.staticFilters["approval"] = "Approved";
        this.staticFilters["paymentType"] = "";
        this.form.get('approval') && this.form.get('approval').setValue('');
        break;
    }
    this.search();
  }
  public setAdvanceState(value) {
    this.staticFilters['advanceState'] = value === "" ? true : false;
    this.setStaticFilterAndSearch('requestedAdvance', value);
  }
  public setAdditionalCostPaid(value) {
    this.staticFilters['additionalCostPaid'] = value === "" ? true : false;
    this.setStaticFilterAndSearch('additionalCost', value);
  }

  public setFilterDriver(value) {
    if (this.typeList === "scheduledLoads") {
      this.staticFilters['state'] = value ? CargoStateEnum.ACCEPTED : CargoStateEnum.CREATED;
      this.search();
    }
  }
  public setFilterAssignedDriver(value: boolean) {
    this.staticFilters['states'] = value ? [CargoStateEnum.ACCEPTED, CargoStateEnum.REQUEST] : [CargoStateEnum.CREATED, CargoStateEnum.REQUEST];
    this.staticFilters['assignedDriver'] = value;
    this.search();
  }
  public setFilterCharges(value: '1' | '2' | '3') {
    this.filterCharges = value;
    let realValues = { cashed: null, checked: null };
    if (value === '1') realValues = { cashed: false, checked: '' };
    else if (value === '2') realValues = { cashed: true, checked: false };
    else realValues = { cashed: true, checked: true };

    this.staticFilters['cashed'] = realValues.cashed;
    this.setStaticFilterAndSearch('checked', realValues.checked);
  }
  public setUserType(type: 'user' | 'userClient') {
    this.staticFilters['type'] = type;
    this.form.get('role') && this.form.get('role').setValue('');
    this.form.get('state') && this.form.get('state').setValue('');
    this.search();
  }

  get filtersByOptions(): { [key: string]: boolean } {
    return this.options.reduce((acc, option) => {
      if (option) acc[option.filterName] = true;
      return acc;
    }, {} as { [key: string]: boolean });
  }
  get dynamicFiltersByOptions(): FilterModel[] {
    return this.options.filter(option => option && option.typeFilter === 'dynamic');
  }
  get staticFiltersByOptions(): FilterModel[] {
    return this.options.filter(option => option && option.typeFilter === 'static');
  }

  //Filtros dinámicos (opcionales y elegibles por el usuario)
  public initDynamicFilters() {
    this.form = this.formBuilder.group({});
    this.dynamicFiltersByOptions.forEach(option => {
      if (!!option.validations && option.controls && Object.keys(option.controls).length) {
        Object.keys(option.controls).forEach(control => {
          try {
            const originalControl = option.controls[control] as FormControl;
            this.form.addControl(control, new FormControl(
              originalControl.value,
              originalControl.validator,
              originalControl.asyncValidator
            ));
          } catch (error) {
            console.error(`No fue posible agregar el control ${control}`, error);
          }
        });
      }
    });

    if (this.filterBy === "cargo") {
      if (this.filtersByOptions.showFilterOriginDestination) {
        this.optionsCityOrigin = { title: 'Orígen', initialValue: '' };
        this.optionsCityDestination = { title: 'Destino', initialValue: '' };
        this.originCity = new FormControl('');
        this.destinationCity = new FormControl('');
      }
      if (this.filtersByOptions.showFilterNumberDocumentDriver) {
        this.optionsDocumentUser = { title: 'N° doc conductor', showUserName: true, initialValue: '', showSearchHint: false }
        this.optionsDocumentUser = { ...this.optionsDocumentUser };
      }
      if (this.filtersByOptions.showFilterUserClient || this.filtersByOptions.showFilterPrevalidation) {
        this.userClientControl.setValue('');
        this.optionsUserClient = { title: this.filtersByOptions.showFilterPrevalidation ? 'Creador del servicio' : 'Usuario web', initialValue: '', appearance: 'outline', showXMark: true };
      }
      if (this.filtersByOptions.showFilterCompany) {
        this.companySelected.setValue('');
        this.optionsCompanyfilter = { title: '', optionAll: true, initialNit: '' };
      }
      if (this.filtersByOptions.showFilterTypeNameLock) {
        this.formControlSatelliteLockType.setValue('');
        this.optionsSatelliteLockType = { title: 'Tipo de candado satelital', initialValue: '' };
      }
      if (this.filtersByOptions.showFilterMultipleCompanies)
        this.companiesControl.setValue('');

      if (this.filtersByOptions.showFilterAmount)
        this.filterAmountValue = null;
      if (this.filtersByOptions.showFilterDate) {
        this.dateLoad = new FormControl(null);
        this.endDate = new FormControl(null);
      }

      if (this.filtersByOptions.showFilterCreationDateInitial && this.filtersByOptions.showFilterCreationDateFinal) {
        this.creationDateInitial = new FormControl(null);
        this.creationDateFinal = new FormControl(null);
      }
    }
    else if (this.filterBy === "vehicle") {
      if (this.filtersByOptions.showFilterVehicleCompany) {
        this.companySelected.setValue('');
        this.optionsCompanyfilter = { title: '', optionAll: true, initialNit: '' };
      }
      if (this.filtersByOptions.showFilterVehicleAccountState)
        this.filterAccountState = { name: 'Todos', value: { stateAccountAdvance: null, stateAccountBalance: null } };
    }
    else if (this.filterBy === "satelliteLock") {
      this.formControlSatelliteLockType.setValue('');
      this.optionsSatelliteLockType = { title: 'Tipo de candado satelital', initialValue: '' };
    }
  }

  get actualFilters(): any {
    let filters = {}
    Object.keys(this.form.controls).forEach(key => {
      let val = this.form.get(key).value;
      if (val !== null && val !== undefined && val !== "") {
        filters[key] = val;
      }
    })
    return filters;
  }
  get someActualFilter(): boolean {
    return !!Object.keys(this.actualFilters).length;
  }

  get appliedFilters(): any {
    let filters = {}
    Object.keys(this.initialFilters).forEach(key => {
      let val = this.initialFilters[key];
      if (val !== null && val !== undefined && val !== "" && key !== "exclusive" && val.length !== 0
        && this.form.get(key)) {
        filters[key] = val;
      }
    })
    return filters;
  }
  get numberOfAppliedFilters(): number {
    return Object.keys(this.appliedFilters).length;
  }


  public changeFilterErrorManifest($event) {
    this.form.get('errorManifest').setValue($event.checked ? true : '');
  }
  get allCompanies(): boolean {
    return this.authService && this.authService.getUserSession().clientCompanyId === environment.rootNit;
  }
  public clearCompany(companyNit) {
    if (!this.form.get('nits').value.includes(companyNit)) return;
    const nitsArr = this.utils.clone(this.form.get('nits').value as string[]);
    const index = nitsArr.indexOf(companyNit);
    if (index === -1) return;
    nitsArr.splice(index, 1);
    this.form.get('nits').setValue(nitsArr.length ? nitsArr : '');
  }

  public setDate($event, type: string) {
    let newDate = DateManager.formatDate($event.value, null, 'YYYY-MM-DD ZZ');
    this.form.get(type === "load" ? "dateLoad" : "endDate").setValue(newDate);
  }

  getRiskProfileName(riskProfileId: string): string {
    const riskProfile = this.riskProfiles.find(profile => profile.id === `${riskProfileId}`);
    return riskProfile ? riskProfile.name : riskProfileId;
  }

  getTravelExpensesStateName(travelExpensesStateId: string): string {
    const travelExpensesState = this.travelExpensesCheckingStates.find(travelExpensesState => travelExpensesState.id === travelExpensesStateId);
    if (travelExpensesState) return travelExpensesState.name;
    if (TravelExpensesStateDict[travelExpensesStateId])
      return TravelExpensesStateDict[travelExpensesStateId];
    return travelExpensesStateId;
  }

  public onChangeCreationDate($event, type: 'creationDateInitial' | 'creationDateFinal') {
    let newDate = DateManager.dateToString($event.value, 'YYYY-MM-DD ZZ');
    this.form.get(type).setValue(newDate);
    if (type === "creationDateInitial") {
      this.creationDateFinal.setValue(null)
      this.form.get('creationDateFinal') && this.form.get('creationDateFinal').setValue('');
    }
  }

  get minCreationDateFinal() {
    if (this.creationDateInitial.value && DateManager.isValidDate(this.creationDateInitial.value)) {
      return new Date(this.creationDateInitial.value);
    }
    return null;
  }

  public clearLastPointLapse($event) {
    if ($event.value === 'false') this.form.get('lastPointLapse').setValue('');
  }

  public selectTag($event) {
    this.tagControl.setValue('');
    if (!this.form.get('labels').value) this.form.get('labels').setValue([$event.value]);
    else if (!this.form.get('labels').value.includes($event.value)) this.form.get('labels').setValue([...this.form.get('labels').value, $event.value]);
  }
  public clearTag(tagName) {
    if (!this.form.get('labels').value.includes(tagName)) return;
    const tagArr = this.utils.clone(this.form.get('labels').value as string[]);
    const index = tagArr.indexOf(tagName);
    if (index === -1) return;
    tagArr.splice(index, 1);
    this.form.get('labels').setValue(tagArr.length ? tagArr : '');
    this.search();
  }

  public setAmount($event) {
    this.isFinite($event.value.start) ?
      this.form.get('startAmount').setValue($event.value.start) :
      this.form.get('startAmount').setValue('');
    this.isFinite($event.value.end) ?
      this.form.get('endAmount').setValue($event.value.end) :
      this.form.get('endAmount').setValue('');
  }
  public setAccountState($event: MatSelectChange) {
    const value: { stateAccountAdvance: boolean, stateAccountBalance: boolean } = $event.value.value;
    this.form.get('stateAccountAdvance').setValue(value.stateAccountAdvance);
    this.form.get('stateAccountBalance').setValue(value.stateAccountBalance);
  }
  public getInitialFilterAccountState(): string {
    if (this.filterBy !== 'vehicle') return '';
    if (!this.appliedFilters['stateAccountAdvance'] && !this.appliedFilters['stateAccountBalance']) return '';
    const option = this.listStateAccountBank.find(option =>
      option.value.stateAccountAdvance == this.appliedFilters['stateAccountAdvance']
      && option.value.stateAccountBalance == this.appliedFilters['stateAccountBalance']
    );
    if (option) return option.name;
    return '';
  }
  public isFinite(n: number): boolean {
    return Number.isFinite(n);
  }
  public onSelectOriginDestination($event, type) {
    $event && $event.data && $event.data.name ?
      this.form.get(type).setValue($event.data.name) :
      this.form.get(type).setValue('');
  }


  //Funciones de aplicado/borrado de filtros
  public onEnterApplyFilter(event: KeyboardEvent): void {
    event.preventDefault();
    this.applyFilter();
  }

  public applyFilter() {
    if (this.form.valid) {
      this.closeLateralFilter();
      this.search();
    } else {
      //Cargo
      if (this.form.get('licensePlate') && this.utils.errorMessagesCustomized(this.form.get('licensePlate'), 'placa', 5, 8)) return;
      else if (this.form.get('escortedLicensePlate') && this.utils.errorMessagesCustomized(this.form.get('escortedLicensePlate'), 'placa escoltada', 5, 8)) return;
      else if (this.form.get('consecutive') && this.utils.errorMessagesCustomized(this.form.get('consecutive'), 'id del servicio', 2, 10)) return;
      else if (this.form.get('container') && this.utils.errorMessagesCustomized(this.form.get('container'), 'contenedor', 11, 11)) return;
      else if (this.form.get('driver') && this.utils.errorMessagesCustomized(this.form.get('driver'), 'documento conductor', 2)) return;
      //User
      else if (this.form.get('document') && this.utils.errorMessagesCustomized(this.form.get('document'), 'documento', null, 15)) return;
      else if (this.form.get('email') && this.utils.errorMessagesCustomized(this.form.get('email'), 'correo ', null, 100)) return;
      //General
      else this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'alert');
    }
  }

  get usesTransportCompanyContext(): boolean {
    return this.filterBy === "cargo" && !!this.filtersByOptions.showFilterTransportCompanyContext;
  }

  /**
   * Primera emisión: resuelve la empresa (la de la URL o la primera) y libera
   * la búsqueda inicial, que search() retiene hasta entonces para no consultar
   * sin empresa. null = SaaS sin transporte: se busca sin transportCompanyId.
   */
  public onTransportCompanyChange(transportCompanyId: string) {
    this.staticFilters['transportCompanyId'] = transportCompanyId || '';
    this.syncTransportCompanyInUrl(transportCompanyId);
    this.transportCompanyResolved = true;
    this.search();
  }

  /** replaceUrl: cambiar de empresa no agrega pasos al historial del navegador. */
  private syncTransportCompanyInUrl(transportCompanyId: string) {
    if (!transportCompanyId || this.route.snapshot.queryParams['transportCompanyId'] === transportCompanyId) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { transportCompanyId },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  public search() {
    if (this.usesTransportCompanyContext && !this.transportCompanyResolved) return;
    let filtersToSessionStorage = "";
    Object.keys(this.form.controls).forEach(key => {
      let val = this.form.get(key).value;
      this.initialFilters[key] = val;
      if (val === null || val === undefined || val === "") {
        delete this.initialFilters[key];
      }
    })
    Object.keys(this.initialFilters).forEach((key) => {
      filtersToSessionStorage += "&" + key + "=" + encodeURIComponent(this.initialFilters[key]);
    });
    this.updateSessionStorage(filtersToSessionStorage, 'dynamic');
    let filtersToSearch = "";
    Object.keys(this.actualFilters).forEach((key) => {
      if (Array.isArray(this.actualFilters[key])) {
        if (this.actualFilters[key].length)
          filtersToSearch += "&" + key + "=" + encodeURIComponent(JSON.stringify(this.actualFilters[key]));
      } else
        filtersToSearch += "&" + key + "=" + encodeURIComponent(this.actualFilters[key]);
    });
    let staticfiltersToSessionStorage = "";
    Object.keys(this.actualStaticFilters).forEach((key) => {
      staticfiltersToSessionStorage += "&" + key + "=" + encodeURIComponent(this.actualStaticFilters[key]);
    });
    Object.keys(this.actualStaticFilters).forEach((key) => {
      if (Array.isArray(this.actualStaticFilters[key])) {
        if (this.actualStaticFilters[key].length)
          filtersToSearch += "&" + key + "=" + encodeURIComponent(JSON.stringify(this.actualStaticFilters[key]));
      } else
        filtersToSearch += "&" + key + "=" + encodeURIComponent(this.actualStaticFilters[key]);
    });
    this.updateSessionStorage(staticfiltersToSessionStorage, 'static');
    sessionStorage.setItem("_activeTab", this.typeList);
    this.refreshList.emit(filtersToSearch);
  }

  public cleanFilter(filter: string, index?: number) {
    switch (filter) {
      case "labels":
        if (this.appliedFilters.labels.length === 1) {
          delete this.initialFilters['labels'];
        }
        else if ((index || index === 0) && this.initialFilters['labels'] && this.initialFilters['labels'].length)
          this.initialFilters['labels'].splice(index, 1);
        break;
      case "nits":
        if (this.appliedFilters.nits.length === 1) {
          this.companiesControl.setValue('');
        }
        if ((index || index === 0) && this.initialFilters['nits'] && this.initialFilters['nits'].length)
          this.initialFilters['nits'].splice(index, 1);
        break;
      case "companyId":
      case "nit":
        this.form.get(filter).setValue('');
        if (this.filterBy !== "vehicle") {
          this.form.get('exclusive') && this.form.get('exclusive').setValue('');
          this.initialFilters["exclusive"] = "";
        }
        this.companySelected.setValue('');
        this.optionsCompanyfilter = {
          title: 'Compañía',
          optionAll: true,
          initialNit: ''
        }
        this.initialFilters[filter] = "";
        break;
      case "typeNameLock":
      case "typeName":
        this.formControlSatelliteLockType.setValue('');
        this.optionsSatelliteLockType = { title: 'Tipo de candado satelital', initialValue: '' };
        if (this.form.get('typeName')) {
          this.form.get('typeName').setValue('');
        }
        if (this.form.get('typeNameLock')) {
          this.form.get('typeNameLock').setValue('');
        }
        this.initialFilters[filter] = "";
        this.initialFilters['typeName'] = "";
        this.initialFilters['typeNameLock'] = "";
        break;
      case "dateLoad":
      case "endDate":
      case "creationDateFinal":
        this[filter] = new FormControl(null);
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        break;
      case "creationDateInitial":
        this.creationDateInitial.setValue(null);
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        this.creationDateFinal.setValue(null);
        this.form.get('creationDateFinal') && this.form.get('creationDateFinal').setValue('')
        this.initialFilters['creationDateFinal'] = "";
        break;
      case "amount":
        this.form.get('startAmount').setValue('');
        this.initialFilters["startAmount"] = "";
        this.form.get('endAmount').setValue('');
        this.initialFilters["endAmount"] = "";
        this.filterAmountValue = null;
        this.initialFilters[filter] = "";
        break;
      case "accountState":
        this.form.get('stateAccountAdvance').setValue('');
        this.form.get('stateAccountBalance').setValue('');
        this.initialFilters['stateAccountAdvance'] = "";
        this.initialFilters['stateAccountBalance'] = "";
        this.filterAccountState = { name: 'Todos', value: { stateAccountAdvance: null, stateAccountBalance: null } };
        break;
      case "origin":
        this.form.get(filter).setValue('');
        this.originCity = new FormControl('');
        this.optionsCityOrigin = {
          title: 'Orígen',
          initialValue: ''
        }
        this.initialFilters[filter] = "";
        break;
      case "destination":
        this.form.get(filter).setValue('');
        this.destinationCity = new FormControl('');
        this.optionsCityDestination = {
          title: 'Destino',
          initialValue: ''
        }
        this.initialFilters[filter] = "";
        break;
      case "driver":
        this.form.get(filter).setValue('');
        this.optionsDocumentUser = { title: 'N° doc conductor', showUserName: true, initialValue: '', showSearchHint: false }
        this.optionsDocumentUser = { ...this.optionsDocumentUser };
        this.initialFilters[filter] = "";
        break;
      case "userClientDocument":
        this.form.get(filter).setValue('');
        this.userClientControl.setValue('');
        this.optionsUserClient = { title: this.filtersByOptions.showFilterPrevalidation ? 'Creador del servicio' : 'Usuario web', initialValue: '', appearance: 'outline', showXMark: true };
        this.initialFilters[filter] = "";
        break;
      case "lastPointExistance":
        this.form.get(filter).setValue('');
        this.form.get('lastPointLapse').setValue('');
        this.initialFilters[filter] = "";
        break;
      case "errorManifest":
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        this.filterErrorManifest.setValue(false);
        break;
      case "imei":
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        break;
      case "stateDevice":
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        break;
      case "typeName":
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        break;
      default:
        this.form.get(filter).setValue('');
        this.initialFilters[filter] = "";
        break;
    }
    this.search();
  }

  public cleanAllFilters() {
    this.initDynamicFilters();
    this.filterErrorManifest.setValue(false);
    this.initialFilters = {};
    this.cleanSessionStorage();
    this.closeLateralFilter();
    this.search();
  }

  public openLateralFilter() {
    this.showLateralFilter = true;
    this.setOptions();
  }

  public closeLateralFilter() {
    this.showLateralFilter = false;
  }

  get scheduledLoadsTab(): boolean {
    return sessionStorage.getItem("_filterListStatic") && sessionStorage.getItem("_filterListStatic").includes('&state=Accepted');
  }

  get cargoStateEnum(): typeof CargoStateEnum {
    return CargoStateEnum;
  }

  get satelliteLockStateDeviceEnum(): typeof SatelliteLockStateDevice {
    return SatelliteLockStateDevice;
  }

  get hasExternalFiltersFirstLine(): boolean {
    return [
      'showFilterAprovedCargo',
      'showFilterMinistryFulfillment',
      'showFilterCharges',
      'showFilterDriver',
      'showFilterRaiting',
      'showFilterTransportRequests',
      'showFilterTypeUser',
      'showFilterTravelExpensesState',
      'showFilterPrevalidation'
    ].some(filter => this.filtersByOptions[filter]);
  }

  get hasExternalFiltersSecondLine(): boolean {
    return [
      'showFilterCharges',
      'showFilterPaymentBalanceCargo',
      'showFilterPaymentAdvanceCargo',
      'showFilterWithoutPayment',
      'showFilterPaymentAdditionalCostsCargo',
      'showFilterPaymentState',
      'showFilterPaymentExpenses',
      'showFilterPaymentExpensesPaymentType',
      'showFilterPublicationZone',
      'showFilterApprovalState',
      'showFilterPrevalidation'
    ].some(filter => this.filtersByOptions[filter]);
  }

  get hasTransportServicesCompany(): boolean {
    return this.authService && this.authService.hasTransportServicesCompany;
  }
  get hasEscortServicesCompany(): boolean {
    return this.authService && this.authService.hasEscortServicesCompany;
  }
  get hasSatelliteLockServicesCompany(): boolean {
    return this.authService && this.authService.hasSatelliteLockServicesCompany;
  }

  ngOnDestroy() {
    this.cdRef.detach();
    if (this.companySub) this.companySub.unsubscribe();
    if (this.companiesSub) this.companiesSub.unsubscribe();
    if (this.cityOriginSub) this.cityOriginSub.unsubscribe();
    if (this.cityDestinationSub) this.cityDestinationSub.unsubscribe();
    if (this.documentDriverSub) this.documentDriverSub.unsubscribe();
    if (this.userClientSub) this.userClientSub.unsubscribe();
  }
}
